import { occUrl, occFetch } from "~/app/api/occ/occFetch";

const occSaveSearchTermUrl = occUrl("/search/save-search-term");

export const saveSearchTerm = async (term: string, url: string) => {
  return await occFetch(occSaveSearchTermUrl, {
    body: JSON.stringify({
      term: term,
      url: url,
    }),
    keepalive: true,
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });
};
